// angular
import { NgOptimizedImage } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// components
import {
  GalleryDialogComponent,
  getGalleryDialogConfig,
} from '@app/core/dialogs/gallery-dialog/gallery-dialog.component';
// services
import { DialogService } from '@app/core/shared/services/dialog.service';
// interfaces
import { IMedia } from '@app/shared/interfaces/media.interface';
// utils
import { resolvePrimaryMediaImagePath } from '@app/shared/utils/media.util';
// pipes
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';
// directives
import { MediaImageFallbackDirective } from '@app/shared/directives/media-image-fallback.directive';

@Component({
  selector: 'pwj-media-photos-grid',
  standalone: true,
  imports: [
    TranslateModule,
    NgOptimizedImage,
    ImageSourcePipe,
    MediaImageFallbackDirective,
  ],
  providers: [ImageSourcePipe],
  templateUrl: './media-photos-grid.component.html',
  styleUrl: './media-photos-grid.component.scss',
})
export class MediaPhotosGridComponent {
  photos = input.required<IMedia[]>();
  showTitle = input(false);
  titleKey = input('personDetail.photos');
  embedded = input(false);
  imageWidth = input('160');
  imageHeight = input('120');

  private readonly _imageSourcePipe = inject(ImageSourcePipe);
  private readonly _dialogService = inject(DialogService);

  public photoSrc(photo: IMedia): string {
    return this._imageSourcePipe.transform(
      resolvePrimaryMediaImagePath(photo),
      false
    );
  }

  public openGalleryDialog(photo: IMedia): void {
    this._dialogService.open(
      GalleryDialogComponent,
      getGalleryDialogConfig({
        title: this.titleKey(),
        mediaData: this.photos(),
        useOriginalUrl: false,
        initialMedia: photo,
      })
    );
  }
}
